import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import type {
  IFooterActionState,
  IFormActionRef,
} from '@app/dashboard/types/innerLayout/profile_details/footer';
import { useSettingsUtils } from '../../../Settings/useSettingsUtils';
import LabelCardInfo from '@app/dashboard/components/inner_layout/LabelCardInfo';

import Header from '../../components/shared/Header';
import PasswordForm from '../../components/changePassword/PasswordForm';
import Footer from '../../components/shared/Footer';

import styles from './ChangePassword.module.scss';

export const ChangePassword = () => {
  const { t } = useTranslation();
  const { internalPagesBreadcrumbs } = useSettingsUtils();
  const footerActionsRef = useRef<IFormActionRef>(null);

  const [footerActions, setFooterActions] = useState<IFooterActionState>({
    isLoading: false,
    shouldDisabledPrimary: false,
    shouldDisabledSecondary: false,
  });

  const handlePrimaryAction = () => {
    footerActionsRef.current?.handleSaveChanges();
  };

  const handleCancelClick = () => {
    footerActionsRef.current?.handleCancelChanges();
  };

  return (
    <div className={styles['change-password']}>
      <Header
        title={t('innerLayout.profileDetailsPage.changePasswordPage.title')}
        breadCrumbs={internalPagesBreadcrumbs.CHANGE_PASSWORD}
      />
      <LabelCardInfo
        label={t(
          'innerLayout.profileDetailsPage.changePasswordPage.changeYourPassword'
        )}
      >
        <PasswordForm
          ref={footerActionsRef}
          setFooterActions={setFooterActions}
        />
      </LabelCardInfo>
      <Footer
        isLoading={footerActions.isLoading}
        shouldDisabledPrimary={footerActions.shouldDisabledPrimary}
        shouldDisabledSecondary={footerActions.shouldDisabledSecondary}
        primaryBtnText={t(
          'innerLayout.profileDetailsPage.changePasswordPage.actions.changePassword'
        )}
        handlePrimaryAction={handlePrimaryAction}
        handleCancelChanges={handleCancelClick}
      />
    </div>
  );
};
